import i18n from 'i18n'

const BOOTSTRAP_MODULE_KEYS: Record<string, string> = {
  branches: 'common.offlineBootstrap.branches',
  permissions: 'common.offlineBootstrap.permissions',
  connectivity: 'common.offlineBootstrap.connectivity',
  pos_catalog: 'common.offlineBootstrap.pos_catalog',
  active_shift: 'common.offlineBootstrap.active_shift',
  tables: 'common.offlineBootstrap.tables',
  expense_categories: 'common.offlineBootstrap.expense_categories',
  cashier_users: 'common.offlineBootstrap.cashier_users',
  pending_actions: 'common.offlineBootstrap.pending_actions',
}

export function formatBootstrapModuleLabel(moduleId: string): string {
  const base = moduleId.split(':')[0] ?? moduleId
  const key = BOOTSTRAP_MODULE_KEYS[base]
  return key ? i18n.t(key) : moduleId
}
